import React from 'react';
import { useDispatch } from 'react-redux';
import {
  setIsCreateModalOpen,
  setSearchField,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import Row from '@amzn/meridian/row';
import { useAppSelector } from 'src/store/store';
import SearchField from '@amzn/meridian/search-field';
import Button from '@amzn/meridian/button';

const TopOptions = () => {
  const dispatch = useDispatch();
  const { searchField } = useAppSelector((state) => state.taskConfigPage);

  return (
    <Row widths={['80%', '20%']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width={'grid-4'}>
        <SearchField
          value={searchField}
          onChange={(newSearchField) => dispatch(setSearchField(newSearchField))}
          placeholder="Search for..."
          onSubmit={() => {}}
        />
      </Row>
      <Button className="view-and-edit-tasks__open-modal" onClick={() => dispatch(setIsCreateModalOpen(true))}>
        Add Tasks/Measurements
      </Button>
    </Row>
  );
};

export default TopOptions;
